export default __webpack_public_path__ + "static/enduringLegacy-7e84a4a7481674904484589072ae4643.webp";